import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { Faq } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi, normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useFaqsList(params: Record<string, string> = {}) {
  return useList<Faq>(`${API_URL}/admin/faqs`, {
    query: params,
  })
}

export function useFaq(id: number | undefined) {
  return useDetail<Faq>(`${API_URL}/admin/faqs`, id?.toString())
}

export function useCreateFaq() {
  return useCreate<Faq>(`${API_URL}/admin/faqs`)
}

export function useUpdateFaq() {
  return useUpdate<Faq>(`${API_URL}/admin/faqs`)
}

export function useDeleteFaq() {
  return useDelete(`${API_URL}/admin/faqs`)
}

export function usePartialUpdateFaq() {
  return usePartialUpdate<Faq>(`${API_URL}/admin/faqs`)
}

export function useDeleteMultiFaq() {
  return useAction(`${API_URL}/admin/faqs/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useFaqLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/faqs/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Faq>
  }, [])
}

export function useFaqsLazy(params: Record<string, string | number | Array<number>> = {}) {
  const auth = useAuth()
  return useCallback((paramsOverride: Record<string, string | number | Array<number>> = {}) => {
    const combinedParams = { ...params, ...paramsOverride }
    const qs = normalizeParams(combinedParams).toString()
    return fetchApi(`${API_URL}/admin/faqs?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Faq[] }>
  }, [])
}
